import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-meta-callback-page',
  templateUrl: './meta-callback.page.html',
  styleUrls: ['./meta-callback.page.scss'],
})
export class MetaCallbackPage implements OnInit {
  message = 'Finalizing Facebook connection...';

  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);
    const payload = {
      type: 'meta-embedded-signup',
      code: params.get('code'),
      state: params.get('state'),
      error: params.get('error'),
      error_description: params.get('error_description'),
    };

    if (payload.error) {
      this.message = payload.error_description || 'Facebook connection was cancelled or failed.';
    } else if (payload.code && payload.state) {
      this.message = 'Facebook approved. Returning to PingoraX...';
    } else {
      this.message = 'No authorization response was returned by Facebook.';
    }

    if (window.opener && window.opener !== window) {
      window.opener.postMessage(payload, window.location.origin);
      window.setTimeout(() => window.close(), 400);
    }
  }
}
